import PropTypes from 'prop-types';
import React from 'react';
import './style.scss';

const TableUnitCell = ({ unitNumber, building, unitType }) => {
  return (
    <div className="TableUnitCell">
      <span className="unit-number">{`${unitNumber} - ${building}`}</span>
      <span className="unit-bed-count">{unitType}</span>
    </div>
  );
};

TableUnitCell.propTypes = {
  unitNumber: PropTypes.string.isRequired,
  building: PropTypes.string.isRequired,
  unitType: PropTypes.string.isRequired,
}

export default TableUnitCell;
